import { useEffect } from 'preact/hooks';
import {
  getSLT,
  getAuthHeaderRTK,
  checkAuthsError,
  getSessionId,
  handleLogout,
  handleAuthResponse,
  checkGenericAuthError,
} from '@sky-uk/ita-js-common-token-manager';

import { fetchTMApi } from '../../components/auth/auth-api';
import logger from '../../services/logging/logging-service';
import { init as initAuth } from '../../components/auth/auth';
import { authActions, authStore } from '../../global-store/subjects/auth';
import { REFRESH_ERROR } from '../utils/errors';

import { useSubscribe } from './use-subscribe';

export const useRefresh = ({ widgetName, errorStatus, errorCode }) => {
  const authState = useSubscribe(authStore);

  useEffect(() => {
    const refreshToken = async () => {
      authActions.refreshStart();
      const authorization = getAuthHeaderRTK();
      const slt = getSLT();
      const sessionId = getSessionId();
      try {
        const httpResponse = await fetchTMApi({
          method: 'PUT',
          data: { slt },
          authorization,
          sessionId,
        });
        const response = await httpResponse.json();

        // Failure
        if (!httpResponse.ok) {
          const error = checkAuthsError(httpResponse?.status, response?.code, true);
          throw new Error(error);
        }

        // Success
        const { isBlacklisted } = handleAuthResponse(response);
        if (isBlacklisted) {
          throw new Error('User in blacklist');
        }
        const userToken = getSLT() || '';
        authActions.refreshSuccess(userToken);
      } catch (error) {
        logger.warn(`[${widgetName}] [Auth] cannot refresh the token from TM - `, error);
        // Remove SLT + RTK from session
        handleLogout();

        // Track refresh failure
        authActions.refreshFailure(error);

        // Try to get a new token from the peterwitt
        initAuth();
      }
    };

    const authError = checkGenericAuthError(errorStatus, errorCode);
    if (!authState.isRefreshing && authError === REFRESH_ERROR) {
      logger.warn(`[${widgetName}] [use-refresh-token:68] [token needs to be refreshed]`);
      refreshToken();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorCode]);
};
